import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function pipelineStartCoroutineUninterceptedOrReturn(interceptor, context, subject, continuation) {
  return (typeof interceptor === 'function' ? interceptor : THROW_CCE())(context, subject, continuation);
}
//region block: exports
export {
  pipelineStartCoroutineUninterceptedOrReturn as pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2,
};
//endregion

//# sourceMappingURL=PipelineJs.mjs.map
